import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Help = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <path
            fillRule="evenodd"
            d="M8.444 39.556Q5.4 36.512 3.73 32.564 2 28.474 2 24t1.73-8.564q1.67-3.948 4.714-6.992Q11.488 5.4 15.436 3.73 19.526 2 24 2t8.564 1.73q3.948 1.67 6.992 4.714 3.044 3.044 4.714 6.992Q46 19.526 46 24t-1.73 8.564q-1.67 3.948-4.714 6.992-3.044 3.044-6.992 4.714Q28.474 46 24 46t-8.564-1.73q-3.948-1.67-6.992-4.714Zm2.828-2.828q2.492 2.492 5.722 3.858Q20.337 42 24 42q3.663 0 7.006-1.414 3.23-1.366 5.722-3.858 2.492-2.492 3.858-5.722Q42 27.663 42 24q0-3.663-1.414-7.006-1.366-3.23-3.858-5.722-2.492-2.492-5.722-3.858Q27.663 6 24 6q-3.663 0-7.006 1.414-3.23 1.366-5.722 3.858-2.492 2.492-3.858 5.722Q6 20.337 6 24q0 3.663 1.414 7.006 1.366 3.23 3.858 5.722Zm7.071-23.76Q16 15.311 16 18.625a2 2 0 1 0 4 0q0-1.657 1.172-2.828 1.171-1.172 2.828-1.172 1.657 0 2.828 1.172Q28 16.968 28 18.625q0 1.657-1.172 2.828-1.171 1.172-2.828 1.172a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0V26.39q2.055-.506 3.657-2.108Q32 21.939 32 18.625t-2.343-5.657Q27.314 10.625 24 10.625t-5.657 2.343ZM24 37.625a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
            style={{ mixBlendMode: 'passthrough' }}
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
